import React, { FunctionComponent } from "react";
import {
  StatusBarWrapper,
  StatusColorBox,
  StatusText,
} from "./StatusBar.Style";
import CheckIcon from "../icons/generated/CheckCircleOutline";
import ErrorIcon from "../icons/generated/WarningTriangleOutline";
import WarningIcon from "../icons/generated/WarningCircleOutline";
import { LoadingIcon } from "@gf-easy-8/grmnext-foundation";
import styled from "styled-components/macro";
import packageJson from "../../../../package.json";
import useStatusBar from "provider/StatusBarProvider";

export enum StatusType {
  DEFAULT = "HEALTHY",
  HEALTHY = "HEALTHY",
  WARNING = "WARNING",
  ERROR = "ERROR",
  LOADING = "LOADING",
}

export type StatusBarProps = {
  status: StatusType;
  text: string;
};

export const StatusBar: FunctionComponent<StatusBarProps> = (
  props: StatusBarProps
) => {
  const { status, text } = props;

  let Icon: FunctionComponent;
  if (status === StatusType.HEALTHY) {
    Icon = CheckIcon;
  } else if (status === StatusType.ERROR) {
    Icon = WarningIcon;
  } else if (status === StatusType.LOADING) {
    Icon = LoadingIcon;
  } else {
    Icon = ErrorIcon;
  }

  return (
    <StatusBarWrapper>
      <StatusColorBox status={status}>
        <Icon />
      </StatusColorBox>
      <StatusText data-test-id="global-status-bar-text">{text}</StatusText>
    </StatusBarWrapper>
  );
};

const ConnectedStatusBar: FunctionComponent<{ className?: string }> = ({
  className,
}) => {
  const { statusBarContext } = useStatusBar();
  const [statusBar] = statusBarContext.statusBar;
  return (
    <div className={className}>
      <StatusBar
        status={statusBar}
        text={`DIGITAL ACTIVATION ADMIN TOOL - v${packageJson.version}`}
      />
    </div>
  );
};

const StatusBarLayout = styled(ConnectedStatusBar)`
  grid-area: status;
`;

export default StatusBarLayout;
